import { inject, Pipe, PipeTransform } from '@angular/core';
import { AgentKeys, AssociationKeys, Lookups, TRUE_FALSE_LOOKUP } from '@ag-common-lib/public-api';
import { of } from 'rxjs';
import { ChangesHistoryGridService } from 'ag-common-svc/lib/components/changes-history-grid/changes-history-grid.service';

@Pipe({
  name: 'getLookupByName',
})
export class GetLookupByNamePipe implements PipeTransform {
  private changesHistoryGridService = inject(ChangesHistoryGridService);

  transform(key: AssociationKeys | AgentKeys | string) {
    if (!key) {
      return null;
    }

    switch (key) {
      case AssociationKeys.isEmergencyContact:
        return of(TRUE_FALSE_LOOKUP);

      case AgentKeys.p_prefix:
      case AssociationKeys.prefix:
        return this.changesHistoryGridService.getLookupByName(Lookups.Prefixes);

      case AssociationKeys.associationType:
        return this.changesHistoryGridService.getLookupByName(Lookups.AssociationType);

      case AgentKeys.p_suffix:
      case AssociationKeys.suffix:
        return this.changesHistoryGridService.getLookupByName(Lookups.Suffixes);

      case AssociationKeys.gender:
        return this.changesHistoryGridService.getLookupByName(Lookups.Genders);

      default:
        return null;
    }
  }
}
